'use client';

import Container from '@/app/_components/container/Container';
import Heading from '@/app/_components/common/heading/Heading';
import styles from '@/app/(pages)/main/main.module.scss';
import Button from '@/app/_components/common/button/Button';
import React from 'react';
import Link from 'next/link';
import { useLoggedInStore } from '@/app/_stores/loggedInStore';
import { ROUTER_PATH } from '@/app/_contants/routerPath';
import Image from "next/image";

export default function Section01() {
  const { isLoggedIn } = useLoggedInStore();

  return (
      <section className={`${styles.section} ${styles.about}`}>
        <Container size={'compact'}>
          <div className={styles.titleBox}>
            <Heading tag={'h2'} level={1}>
              <span className={'text-primary'}>GPT Killer</span>は誰が利用しますか？
            </Heading>
          </div>

          <ul className={styles.aboutList}>
            <li className={styles.aboutItem}>
              <div className={styles.imageContainer}>
                <img src={'/images/main/section01_1.png'} alt="학생 이미지"/>
              </div>
              <div className={styles.contentContainer}>
                <dl>
                  <dt>
                    <span>学生</span>
                  </dt>
                  <dd>
                    <ul>
                      <li>レポートを提出する前に検査を行うことで、生成AIに関する不利益を防ぐことができます。</li>
                      <li>生成AIの助けを借りて作成したレポートを、自分の言葉で再構成する際に役立ちます。</li>
                    </ul>
                  </dd>
                </dl>
              </div>
            </li>
            <li className={styles.aboutItem}>
              <div className={styles.imageContainer}>
                <img src={'/images/main/section01_2.png'} alt="교수·연구자 이미지"/>
              </div>
              <div className={styles.contentContainer}>
                <dl>
                  <dt>
                    <span>教授・研究者</span>
                  </dt>
                  <dd>
                    <ul>
                      <li>学会やジャーナルへの論文投稿において、生成AIによる研究倫理違反のリスクを事前に防げます。</li>
                      <li>担当する授業で、学生が不適切な方法で生成AIを使用しているかを検出できます。</li>
                    </ul>
                  </dd>
                </dl>
              </div>
            </li>
            <li className={styles.aboutItem}>
              <div className={styles.imageContainer}>
                <img src={'/images/main/section01_3.png'} alt="마케터·사무원 이미지"/>
              </div>
              <div className={styles.contentContainer}>
                <dl>
                  <dt>
                    <span>マーケター・事務員</span>
                  </dt>
                  <dd>
                    <ul>
                      <li>コンテンツが、YahooやGoogleなどのポータルサイトでAIコンテンツと判定され、検索結果の上位に表示されないリスクを事前に防ぐことができます。</li>
                      <li>重要な報告書の作成などの業務プロセスにおいて、生成AIの過剰な使用を防ぐことができます。</li>
                    </ul>
                  </dd>
                </dl>
              </div>
            </li>
          </ul>
          <div className={styles.btnArea}>
            <Link href={isLoggedIn ? '/results' : ROUTER_PATH.LOGIN}>
              <Button type="button" variants={'secondary'}>
                <span>今すぐ利用する</span>
              </Button>
            </Link>
          </div>
        </Container>
      </section>
  );
}